import React from 'react';
import { Outlet } from 'react-router-dom';

const AuthLayout = () => {
  return (
    <div>
      <Outlet /> {/* Renders auth routes like login/register */}
    </div>
  );
};

export default AuthLayout;